// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3yQr0","errorLogs":"styles_errorLogs__3Nbfd"};